<div class="loading-percent">
  <mzic-spinner></mzic-spinner>
  <span class="loading-percent__value">{{ percent.toFixed(0) }}%</span>
</div>
